<div class="error_page">
    <div class="error_page_name">404</div>
    <img src="/assets/img/404-error.png" class="error_page_img">
    <div class="error_page_title">Whoops!</div>
    <div class="error_page_text">The page you are looking for is not available!</div>
    <a class="error_page_btn" *ngIf="overViewAvailable$ | async" [routerLink]="toOverview">Go to Overview Page</a>
</div>
<div id="roadmap-paint-finished"></div>
